import { useFormik } from "formik";
import React, { ForwardRefRenderFunction, forwardRef, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Input } from "sr/helpers";
import { InputNumberFormat } from "sr/helpers/functions/InputNumberFormat";
import * as Yup from "yup";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { changeContact } from "sr/utils/api/corporate/changeContact";

interface ChangePhoneProps {
  HandleModel?: (open: boolean) => void;
  onOtpSent?: (channel: "Email" | "PhoneNo") => void;
}

const ChangePhone: ForwardRefRenderFunction<any, ChangePhoneProps> = (
  { onOtpSent,HandleModel },
  ref
) => {
  const intl = useIntl();
  const [corporateId, setCorporateId] = useState<string>("");

  useEffect(() => {
    const details = getUserDetails();
    if (details?.user_id) setCorporateId(details.user_id);
  }, []);

  const PhoneSchema = Yup.object({
    mobile_number: Yup.string().required("INPUT.VALIDATION.MOBILENUMBER"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { mobile_number: "" },
    validationSchema: PhoneSchema,
    onSubmit: async (values, { setErrors, setSubmitting }) => {
      try {
        const res = await changeContact({ corporateId, mobile_number: values.mobile_number });
        if (res?.success === true && res?.message === "OTP.SENT") {
          onOtpSent?.("PhoneNo");
          HandleModel?.(false);
        } else {
          setErrors({ mobile_number: res?.message || "Something went wrong" });
        }
      } finally {
        setSubmitting(false);
      }
    },
  });

  React.useImperativeHandle(ref, () => ({
    submitForm: formik.submitForm,
  }));

  return (
    <>
      <Input
        name="mobile_number"
        value={InputNumberFormat(formik.values.mobile_number)}
        onChange={formik.handleChange}
        error={formik.errors.mobile_number}
        InputDivClass="mt-0"
        inputClass="border border-zinc-800 rounded-lg h-11"
        label={intl.formatMessage({
          id: "CORPORATE.ACCOUNT.SETTINGS.NEW_PHONENO.TITLE",
          defaultMessage: "New Phone Number",
        })}
      />
      {formik.isSubmitting && <p className="text-blue-600 text-sm mt-2">Sending OTP...</p>}
    </>
  );
};

export default forwardRef(ChangePhone);
